<template>
  <div v-if="user">
    {{ user.name }}
    {{ user.photoURL }}
  </div>
</template>

<script>
import {db} from "@/firebase/db.js"

export default {
  data: () => ({
    user: null,
  }),
  async created() {
    const unameDoc = await db.collection("usernames").doc(this.$route.params.user_name).get()
    if (unameDoc.exists) {
      const userRef = db.collection("users").doc(unameDoc.data().user)
      this.$bind('user', userRef)
    }
  }
}
</script>



